<div class="chart-scroll-wrapper">
  <div class="chart" id="vis"></div>
</div>
